import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api from "../lib/api";

// Site-wide scrolling announcement bar, configured from the admin console.
export default function AnnouncementBar() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/announcement").then(({ data }) => { if (alive) setCfg(data); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!cfg?.enabled || !cfg.text?.trim()) return null;

  const accent = cfg.color || "#0066FF";
  // repeat the message so the marquee loops seamlessly (we animate -50%)
  const run = Array(6).fill(cfg.text.trim());

  return (
    <div
      data-testid="announcement-bar"
      className="announce-bar relative z-[60] overflow-hidden border-b border-white/10"
      style={{ background: `linear-gradient(90deg, ${accent}1a, ${accent}33, ${accent}1a)` }}
    >
      <div className="relative flex items-center">
        <span className="shrink-0 flex items-center gap-1.5 pl-3 pr-2 py-1.5 text-white" style={{ color: accent }}>
          <Megaphone size={13} />
        </span>
        <div className="overflow-hidden flex-1 py-1.5">
          <div className="animate-marquee flex whitespace-nowrap" style={{ animationDuration: `${cfg.speed || 30}s`, width: "max-content" }}>
            {run.map((t, i) => (
              <span key={i} className="mx-6 font-mono text-[12px] uppercase tracking-[0.18em] text-white/90">
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
